import { Divider } from '@faceup/ui-base'
import { type FragmentType, getFragmentData, graphql } from '../../../../__generated__'
import { useReportMenuItems } from '../../../../hooks/useReportMenuItems'
import { LanguageDropdown } from '../../../LanguageDropdown/LanguageDropdown'
import { MenuItems } from '../../../MenuItems/MenuItems'

const fragments = {
  InstitutionLayoutWebFooter_reportSource: graphql(`
    fragment InstitutionLayoutWebFooter_reportSource on PublicReportSource {
      id
      languages
      defaultLanguage
      institution {
        id
        billing {
          id
          plan
        }
      }
    }
  `),
}

type WebFooterProps = {
  reportSource: FragmentType<typeof fragments.InstitutionLayoutWebFooter_reportSource>
  shouldShowLanguagesDropdown: boolean
}

export const WebFooter = ({
  reportSource: _reportSource,
  shouldShowLanguagesDropdown,
}: WebFooterProps) => {
  const reportSource = getFragmentData(
    fragments.InstitutionLayoutWebFooter_reportSource,
    _reportSource
  )
  const reportMenuItems = useReportMenuItems({
    plan: reportSource.institution?.billing?.plan,
  })

  return (
    <div className='fixed inset-x-0 bottom-0'>
      <Divider />
      <div
        className={
          shouldShowLanguagesDropdown ? '' : 'pointer-events-none invisible absolute opacity-0'
        }
      >
        <div className='bg-white px-6 py-3'>
          <LanguageDropdown
            availableLanguages={reportSource.languages}
            defaultLanguage={reportSource.defaultLanguage}
          />
        </div>
        <Divider />
      </div>
      <div>
        <div className='bg-white p-6'>
          <MenuItems items={reportMenuItems} />
        </div>
      </div>
    </div>
  )
}
